export const CHOOSE_ALIGNER = 'choose_aligner'


export const PRODUCE_MISSING_ALIGNER_EXTERNAL = 'produce_missing_aligner_external'



// WEBPACK FOOTER //
// ./src/modules/process/ui-definition/sales-order/aligner-reproduction/task-name.js